import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { User } from 'src/app/shared/models/user';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  activeMetric = 'events';
  events: any[] = []; // Create an empty array to store events
  followers: User[] = []; // Create an empty array to store followers

  constructor(private dataService: DataService,
    private authService: AuthService) { }

  ngOnInit(): void {
    // When the component is initialized, fetch events and followers
    this.fetchEvents();
    this.fetchFollowers();
  }

  fetchEvents() {
    if (!this.authService.userData.brandId) {
      this.authService.signOut();
    } else {
      this.dataService.getEventsFromUser(this.authService.userData.brandId).then((res)=>{
        console.log('');
        console.log('');
        console.log('res ', res );
        console.log('');
        console.log('');
      }).catch((e)=>{
        console.log('e ', e);
      })
    }
    // Use the DataService to fetch events
  }

  fetchFollowers() {
    // Use the DataService to fetch followers
    this.dataService.getFollowersFromUser(this.authService.userData.brandId).then((res) => {
      console.log('');
      console.log('');
      console.log('users ', res );
      console.log('');
      console.log('');
    }).catch((e)=>{
      console.log('e ', e);
    })
  }

}
